import { FlexColumn, StyledBanner, StyledButton } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useStyles } from '../../hooks/useStyles';
import { ForgottenPasswordForm } from '../forgottenPassword/ForgottenPasswordForm';
import { LoginContainer } from '../login/LoginContainer';
import { HeadTitle } from '../shared/HeadTitle';
import { StyledRouterLink } from '../ui/StyledRouterLink';

export function ForgottenPasswordPage() {
  const [username, setUsername] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [codeSend, setCodeSend] = useState(false);
  const [error, setError] = useState('');
  const { sendCode, resetForgotPassword } = useAuth();
  const navigate = useNavigate();
  const { css, theme } = useStyles();

  const resetPassword = async () => {
    if (codeSend) {
      const response = await resetForgotPassword(username, code, password);
      if (response?.error) {
        setError(`${response.error}`);
      } else {
        navigate('/', { replace: true });
      }
    } else {
      await sendResetPasswordCode();
    }
  };

  const sendResetPasswordCode = async () => {
    setLoading(true);
    const response = await sendCode(username);
    if (response?.error) {
      setError(`${response.error}`);
    } else {
      setCodeSend(true);
      setUsername(response.user?.nextStep.codeDeliveryDetails.destination ?? 'este usuario');
    }
    setLoading(false);
  };

  return (
    <LoginContainer>
      <HeadTitle title="Olvidé mi contraseña" />
      <FlexColumn centered>
        {error && (
          <StyledBanner
            title="*Error*"
            kind="negative"
            full
            action={{
              label: 'Label',
              onClick: () => {
                setError('');
              },
            }}
          >
            {error}
          </StyledBanner>
        )}
        {codeSend && (
          <div className={css({ maxWidth: '320px', textAlign: 'justify' })}>
            Si existe una cuenta asociada a {username}, te enviaremos un correo electrónico con un código. Ingresa el
            código para restablecer tu contraseña.
          </div>
        )}
        <ForgottenPasswordForm
          codeSend={codeSend}
          user={username}
          code={code}
          password={password}
          onChangeUser={setUsername}
          onChangeCode={setCode}
          onChangePass={setPassword}
        />
        <StyledButton
          full
          size="default"
          onClick={resetPassword}
          isLoading={loading}
          disabled={codeSend && !code}
        >
          {codeSend ? 'Restablecer Contraseña' : 'Enviar Codigo'}
        </StyledButton>
        <StyledRouterLink
          to="/login"
          className={css({ marginTop: theme.sizing.scale600 })}
        >
          Regresar
        </StyledRouterLink>
      </FlexColumn>
    </LoginContainer>
  );
}
